mutation AddStaffMember($email: String!) {
  result: StreamToolsAddStaffMember(email: $email) {
    accountId
    alreadyListed
  }
}
